"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var extrasStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        container: {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            justifyContent: 'start',
        },
        actionButtonContainer: (_b = {
                marginBottom: 10
            },
            _b[breakpoints.down('sm')] = {
                padding: '0 15px',
            },
            _b),
    });
}, { name: 'Checkout4_Extras' });
exports.default = extrasStyles;
